import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["dynamicSubmit"]
    static values = {
        format: String
    }

    submit() {
        let action = `${this.element.action}`
        let new_action = `${action}.${this.formatValue}`
        this.element.action = new_action;
        event.preventDefault()
        this.element.requestSubmit();
        this.element.action = action;
    }
}
